import { useBWTokenContext } from 'env/context/bwTokenContext';

export const useGymWaiverStatus = () => {
  const { gymWaiverStatus, gymWaiverExpiryDate, hideExpiredMessage } =
    useBWTokenContext();

  return {
    gymWaiverStatus,
    gymWaiverExpiryDate,
    hideExpiredMessage,
  };
};
